import React from 'react'
import { SVGIconProps } from '../types'
const SvgViewArray = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M4 18h3V5H4zM18 5v13h3V5zM8 18h9V5H8z" />
  </svg>
)
export default SvgViewArray
